import { Icon, lighten, styled } from "@mui/material";
// GLOBAL CUSTOM COMPONENTS
import { FlexAlignCenter } from "./FlexBox";

// STYLED COMPONENT
const RectangleRoot = styled(FlexAlignCenter)(({ theme, color }) => ({
  opacity: 1,
  "& h5": {
    margin: 0,
    fontWeight: "500",
    color: theme.palette.primary.main
  },
  background:
    color === "primary"
      ? `rgba(var(--primary), 0.15) !important`
      : color === "green"
      ? "rgba(9, 182, 109, 0.15) !important"
      : color === "green"
      ? `${lighten(theme.palette.secondary.main, 0.85)}`
      : `${lighten(theme.palette.error.main, 0.85)}`
}));

export default function RectangleAvatar({ icon, textIcon, style }) {
  return (
    <RectangleRoot sx={style}>
      {textIcon ? <h5>{textIcon}</h5> : <Icon sx={{ color: "primary.main" }}>{icon}</Icon>}
    </RectangleRoot>
  );
}
